import React, { useState } from 'react';
import {
    TopEventsState,
    TopEventsSportSingleType,
} from 'src/domains/layouts/webview/components/topEvents/TopEventsState.state';
import { observer } from 'src/utils/mobx-react';
import { CompetitionData } from 'src/domains/layouts/webview/components/promotedSports/CompetitionData';
import { Collapse } from 'src/ui/components/collapse/sports/02/Collapse';
import { TopEventsSportSectionWrapperState } from 'src/domains/layouts/webview/components/topEvents/TopEventsSportSectionWrapper.state';
import { SdkCustomer } from 'src/domains/layouts/state/customer';
import { useCommon } from 'src/domains/common/Common';

interface TopEventsSportWrapperPropsType {
    sportSlug: string;
    sportData: TopEventsSportSingleType;
    topEventsState: TopEventsState;
}

export const TopEventsSportSectionWrapper = observer(
    'TopEventsSportSectionWrapper',
    ({ sportSlug, sportData }: TopEventsSportWrapperPropsType) => {
        const common = useCommon();
        const { models } = SdkCustomer.get(common);
        const [state] = useState(() => new TopEventsSportSectionWrapperState());

        const sportName = models.getSport(sportSlug)?.name ?? '-';
        const competitionsSorted = sportData.competitions_list.sort((a, b) => a.display_order - b.display_order);

        return (
            <>
                <Collapse
                    data-test='topEvents-event-group'
                    handleToggle={state.setIsOpened}
                    isOpen={state.isOpenedSport}
                    title={sportName}
                    sportId={sportName}
                />
                {state.isOpenedSport ? (
                    <>
                        {competitionsSorted.map((competition) => (
                            <CompetitionData
                                key={competition.id}
                                sportSlug={sportSlug}
                                competition={competition}
                            />
                        ))}
                    </>
                ) : null}
            </>
        );
    }
);
